import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { PlanInterface } from '../models/plan.model';

@Injectable({ providedIn: 'root' })
export class PlanesService extends ApiService<PlanInterface> {
  url = "planes";
}
